'use strict';

class LocationsNewController {
  constructor($scope,
              $filter,
              $state,
              $window,
              utils,
              config,
              LocationsService,
              UsersService) {

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';

    $scope.helpers = {};
    let $helpers = $scope.helpers;
    $helpers.step = 1;
    $helpers.totalStep = 2;

    $scope.chooseOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.allOrgs = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);
    $scope.adminInfo = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);

    // List of current organization and all child organizations
    $scope.organizations = utils.getChildOrganizations($scope.allOrgs, $scope.chooseOrg.id) || [];
    $scope.organizations.unshift($scope.chooseOrg);
    $helpers.selectedOrganizationId = $scope.chooseOrg.id;
    $helpers.selectedOrganization = $scope.chooseOrg;

    $scope.locationsTypes = config.getLocationTypes();
    $scope.locationSubTypes = config.getLocationSubTypes();
    $scope.usagePeriods = config.getConfigByKey('usagePeriods');
    $scope.heatingTypes = config.getConfigByKey('heatingTypes');
    $scope.coolingTypes = config.getConfigByKey('coolingTypes');
    $scope.waterHeaterTypes = config.getConfigByKey('waterHeaterTypes');
    $scope.thermostatTypes = config.getConfigByKey('thermostatTypes');
    $scope.sizeTypes = [
      {
        'name': $t('locations.sizes.ft2'),
        'value': 'ft2'
      }, {
        'name': $t('locations.sizes.m2'),
        'value': 'm2'
      }
    ];
    $helpers.selectedLocationTypeId = '10'; //default type
    $helpers.selectedSizeTypeValue = 'ft2'; //default size type
    $scope.loading = false;

    angular.extend($scope, {
      saveBasicInfo: saveBasicInfo,
      gotoStep: gotoStep,
      saveLocation: saveLocation,
      navigateBack: navigateBack,
    });

    $('#dropdown-size-type').dropdown();

    // #region Form validation
    $.fn.form.settings.rules.zipRule = function(value) {
      if (!value || value == '') {
        return true;
      }
      if ($helpers.selectedCountry && $helpers.selectedCountry.zipFormat) {
        return new RegExp($helpers.selectedCountry.zipFormat).test(value);
      }
      return true;
    };

    $.fn.form.settings.rules.integerOrEmpty = function(value, n) {
      if (!value || value == '') {
        return true;
      }
      return $.fn.form.settings.rules.integer(value, n);
    };

    $.fn.form.settings.rules.numberOrEmpty = function(value, n) {
      if (!value || value == '') {
        return true;
      }
      let flag = $.fn.form.settings.rules.number(value);
      if (flag) {
        if (n) {
          let arr = n.split('..');
          let min = arr.length >= 1 ? Number(arr[0]) : Number.MIN_VALUE,
            max = arr.length >= 2 ? Number(arr[1]) : Number.MAX_VALUE,
            valNum = Number(value);
          return valNum >= min & valNum <= max;
        } else {
          return true;
        }
      }
      return false;
    };

    $('#form-loc-basic-info').form({
      inline: true,
      fields: {
        'name': {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.locations.name.empty')
            }
          ]
        },
        'zip': {
          rules: [
            {
              type: 'zipRule',
              prompt: $t('prompt.zip.reg')
            }
          ]
        }
      }
    });

    $('#form-loc-append-info').form({
      inline: true,
      fields: {
        'latitude': {
          rules: [
            {
              type: 'numberOrEmpty[-90..90]',
              prompt: $t('prompt.locations.latitude')
            }
          ]
        },
        'longitude': {
          rules: [
            {
              type: 'numberOrEmpty[-180..180]',
              prompt: $t('prompt.locations.longitude')
            }
          ]
        },
        'size': {
          rules: [
            {
              type: 'numberOrEmpty',
              prompt: $t('prompt.locations.numberOrEmpty')
            }
          ]
        },
        'stories': {
          rules: [
            {
              type: 'integerOrEmpty',
              prompt: $t('prompt.locations.integerOrEmpty')
            }
          ]
        },
        'rooms': {
          rules: [
            {
              type: 'integerOrEmpty',
              prompt: $t('prompt.locations.integerOrEmpty')
            }
          ]
        },
        'bathrooms': {
          rules: [
            {
              type: 'integerOrEmpty',
              prompt: $t('prompt.locations.integerOrEmpty')
            }
          ]
        },
        'occupants': {
          rules: [
            {
              type: 'integerOrEmpty',
              prompt: $t('prompt.locations.integerOrEmpty')
            }
          ]
        }
      }
    });
    // #endregion

    init();

    function init() {
      $scope.selectedLocationSubTypeId = $state.params.parentId ? 1 : 0;
      // Do not allow to change location sub-type if parent ID is specified
      $scope.lockedSubType = !!$state.params.parentId;

      initWatchers();
      getCountries();
      getLanguages();
    }

    function initWatchers() {
      $scope.$watchGroup(['helpers.selectedCountry', 'helpers.selectedCountryId'], function() {
        changeCountry();
      });

      $scope.$watch('helpers.step', function() {
        $helpers.stepStr = $t('locations.new.step', {
          current: $helpers.step,
          total: $helpers.totalStep
        });
      });
    }

    function getCountries() {
      return LocationsService.getCountries()
        .then(function(data) {
          $scope.countries = data.countries;

          // Set default country based on current organization
          if ($helpers.selectedOrganization && $helpers.selectedOrganization.country) {
            $helpers.selectedCountryId = $helpers.selectedOrganization.country.id;
          }
        });
    }

    function changeCountry() {
      if (!$helpers.selectedCountry) {
        $scope.states = null;
        return;
      }
      $scope.states = $helpers.selectedCountry.states;
      let selectedStateId = $helpers.selectedOrganization && $helpers.selectedOrganization.state && $helpers.selectedOrganization.country && $helpers.selectedOrganization.country.id === $helpers.selectedCountry.id ? $helpers.selectedOrganization.state.id : null;
      let selectedState = $scope.states ? $scope.states.find(s => s.id === selectedStateId) : undefined;
      $helpers.selectedStateId = selectedState ? selectedState.id : null;

      $scope.timezones = $helpers.selectedCountry.timezones ?
        $helpers.selectedCountry.timezones.map(tz => {
          return {
            ...tz,
            gmt: getTimezoneGmtString(tz) // additional field for dropdown
          };
        }) : [];
      $helpers.selectedTimezoneId = $scope.timezones && $scope.timezones.length > 0 ? $scope.timezones[0].id : null;
    }

    /**
     * Get GMT string for timezone
     * @param {{id: string, offset: number, ...}} timezone
     * @return {string}
     */
    function getTimezoneGmtString(timezone) {
      let prefix = timezone.offset < 0 ? '-' : '+';
      let offset = timezone.offset || null;
      return $t('datetime.timezone', {
        name: timezone.id,
        hours: prefix + utils.convertMinutes(Math.abs(offset))
      });
    }

    function getLanguages() {
      UsersService.getSupportedLanguages()
        .then(data => {
          $scope.languages = data;
          if ($scope.adminInfo && $scope.adminInfo.user && $scope.adminInfo.user.language) {
            $helpers.selectedLanguageId = $scope.adminInfo.user.language;
          }
        });
    }

    function saveBasicInfo() {
      if (!$('#form-loc-basic-info').form('is valid')) {
        return;
      }
      $scope.gotoStep(2);
    }

    function gotoStep(step) {
      $helpers.step = step;
    }

    function saveLocation() {
      if (!$('#form-loc-append-info').form('is valid')) {
        return;
      }
      if ($scope.loading) {
        return;
      }
      $scope.loading = true;
      return createLocation()
        .then(() => {
          $scope.loading = false;
          navigateBack();
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function createLocation() {
      $helpers.latitude = !$helpers.latitude ? void 0 : $helpers.latitude;
      $helpers.longitude = !$helpers.longitude ? void 0 : $helpers.longitude;
      let locationInfo = {
        'location': {
          'name': $helpers.name,
          'type': $helpers.selectedLocationTypeId,
          'addrStreet1': $helpers.addrStreet1,
          'addrStreet2': $helpers.addrStreet2,
          'addrCity': $helpers.addrCity,
          'zip': $helpers.zip,
          'latitude': $helpers.latitude,
          'longitude': $helpers.longitude,
          'storiesNumber': $helpers.storiesNumber,
          'roomsNumber': $helpers.roomsNumber,
          'bathroomsNumber': $helpers.bathroomsNumber,
          'occupantsNumber': $helpers.occupantsNumber,
          'usagePeriod': $helpers.selectedPeriodId,
          'heatingType': $helpers.selectedHeatingId,
          'coolingType': $helpers.selectedCoolingId,
          'waterHeaterType': $helpers.selectedWaterId,
          'thermostatType': $helpers.selectedThermostatId,
          'language': $helpers.selectedLanguageId,
          'subType': $scope.selectedLocationSubTypeId,
        }
      };

      if ($helpers.sizeValue) {
        locationInfo.location.size = {
          'unit': $helpers.selectedSizeTypeValue,
          'content': $helpers.sizeValue,
        };
      }

      if ($helpers.selectedCountryId) {
        locationInfo.location.country = {
          'id': $helpers.selectedCountryId
        };

        if ($helpers.selectedStateId) {
          locationInfo.location.state = {
            'id': $helpers.selectedStateId
          };
        }
      }

      if ($helpers.selectedTimezoneId) {
        locationInfo.location.timezone = {
          'id': $helpers.selectedTimezoneId
        };
      }

      return LocationsService.createLocation(
        $helpers.selectedOrganizationId || $scope.chooseOrg.id, locationInfo,
          $state.params.parentId ? { parentId: parseInt($state.params.parentId) } : {});
    }

    function navigateBack($event) {
      if ($state.params.from === 'location' && $state.params.parentId) {
        $state.go('main.locations.edit', { locationId: $state.params.parentId, tab: $state.params.fromTab || 'dashboard' });
      } else {
        $state.go('main.locations.list');
      }
    }
  }
}

export default angular
  .module('main.locationsNew.controller', [])
  .controller('LocationsNewController', LocationsNewController)
  .name;
